import { useCallback, useState } from 'react';
import {
  DEFAULT_DISCOVERY_VIEW_MODE,
  DISCOVERY_VIEW_MODE_STORAGE_KEY,
  DiscoveryViewMode,
  parseDiscoveryViewMode,
} from '../constants/discoveryViewMode';

/** FEAT-085 — localStorage-backed Faces/Cards preference for discovery lists. */
export function useDiscoveryViewMode() {
  const [viewMode, setViewModeState] = useState<DiscoveryViewMode>(() => {
    if (typeof window === 'undefined') {
      return DEFAULT_DISCOVERY_VIEW_MODE;
    }
    return parseDiscoveryViewMode(localStorage.getItem(DISCOVERY_VIEW_MODE_STORAGE_KEY));
  });

  const setViewMode = useCallback((mode: DiscoveryViewMode) => {
    setViewModeState(mode);
    localStorage.setItem(DISCOVERY_VIEW_MODE_STORAGE_KEY, mode);
  }, []);

  return { viewMode, setViewMode };
}
